import { render, staticRenderFns } from "./Invitation.vue?vue&type=template&id=65294f1a&scoped=true&"
import script from "./Invitation.vue?vue&type=script&lang=ts&"
export * from "./Invitation.vue?vue&type=script&lang=ts&"
import style0 from "./Invitation.vue?vue&type=style&index=0&id=65294f1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65294f1a",
  null
  
)

export default component.exports